import React from 'react';
import { FormattedMessage } from 'react-intl';
import Layout from '../../../components/Layout/Layout';
import Card from '../../../components/Card/Card';
import TicketsList from '../../../components/Tickets/TicketsList';
import Pagination from '../../../components/Pagination/Pagination';
import { Link } from 'react-router-dom';
import { NavLink } from 'reactstrap';
import { STATIC_PATH } from '../../../config';
import { Modal, ModalBody } from 'reactstrap';
import Ticket from './../Ticket';

const View = ({
  data: { loading, page, tickets, pageCount, isTicketModalOpen, selectedTicketId },
  cardHeaderRef,
  changePage,
  toggleTicketModal,
}) => {
  return (
    <>
      <Layout formattedTitle="pages.tickets.title" className="tickets-page">
        <div className="tickets-create-btn">
          <NavLink className="btn btn-primary btn-sm" to="/tickets/create" tag={Link}>
            <FormattedMessage id="tickets.create_ticket" defaultMessage="Create Ticket" />
          </NavLink>
        </div>
        <Layout.Col>
          <Card loading={loading} innerRef={(el) => (cardHeaderRef = el)}>
            <p className="tickets-page-title">Список тикетов</p>

            <Card.Body className="no-padding">
              {tickets.length > 0 ? (
                <TicketsList
                  total={pageCount}
                  tickets={tickets}
                  toggleTicketModal={toggleTicketModal}
                />
              ) : (
                <div className="card-empty">
                  <img
                    className="card-empty-img"
                    src={`${STATIC_PATH}/img/tickets.png`}
                    alt="tickets"
                    width="120"
                    height="120"
                  />
                  <p className="card-empty-title">
                    <FormattedMessage id="tickets.no_tickets_title" defaultMessage="No Tickets" />
                  </p>
                  <p className="card-empty-subtitle">
                    <FormattedMessage
                      id="tickets.no_tickets_subtitle"
                      defaultMessage="No Tickets"
                    />
                  </p>
                  <NavLink
                    className="btn btn-primary card-empty-btn"
                    to="/tickets/create"
                    tag={Link}
                  >
                    <FormattedMessage id="tickets.create_ticket" defaultMessage="Create Ticket" />
                  </NavLink>
                </div>
              )}
            </Card.Body>

            {pageCount > 1 && (
              <Card.Footer>
                <Pagination
                  pageCount={pageCount}
                  onPageChange={changePage}
                  activePage={page + 1}
                  scrollToAfterPageChanged={{
                    ref: cardHeaderRef,
                  }}
                />
              </Card.Footer>
            )}
          </Card>
        </Layout.Col>
      </Layout>
      <Modal
        isOpen={isTicketModalOpen}
        modalClassName="modal-sidebar-ticket"
        backdrop={true}
        toggle={toggleTicketModal}
      >
        <ModalBody>
          <Ticket id={selectedTicketId} toggleTicketModal={toggleTicketModal} />
        </ModalBody>
      </Modal>
    </>
  );
};

export default View;
